<template>
  <Popover class="relative">
    <PopoverButton>
      <textarea
        v-if="!open"
        :class="`border-${color}`"
        placeholder="参加者を入力してください"
        class="w-full border focus:outline-none px-3 py-3 resize-none"
        style="border-radius: 20px; width:680px;"
        rows="1"
        :value="modelValue ? modelValue : ''"
        @input="$emit('update:modelValue', $event.target.value)"
        @click="checkHighlightedUsers(items, modelValue), (open = true)"
      />
    </PopoverButton>

    <span
      v-if="!open"
      :class="`text-${color}`"
      style="display:block;text-align:right"
    >
      [入力数{{ modelValue ? count(modelValue) : 0 }}名]
    </span>

    <table v-if="open" style="font-size:18px;">
      <thead
        class="w-full border border-bottom-dashed bg-white px-1 py-1 mt-1 absolute z-20"
        style="border-radius: 20px 20px 0 0;top: -130px; border-bottom-style: dashed;padding:8px;"
        :class="`border-${color}`"
        @mousedown.stop=""
      >
        <user-not-circle-icn
          width="25px"
          height="25px"
          class="mr-2"
          style="float: left;"
          fill="#2993CE"
        ></user-not-circle-icn>
        <span class="font-bold" :class="`text-${color}`" style="float: left;">
          候補議員 |</span
        >
      </thead>
      <tbody
        class="w-full border bg-white px-1 py-1 mt-1 absolute z-10"
        style="border-radius: 0 0 20px 20px;top: -90px; border-top-style:none; height:85px; overflow: scroll;"
        :class="`border-${color}`"
        @mousedown.stop=""
      >
        <tr v-for="rowIndex in Math.ceil(items.length / 3)" :key="rowIndex">
          <td v-for="index in 3" :key="`td-${index}`">
            <button
              type="button"
              v-if="items[index - 1 + (rowIndex - 1) * 3]"
              :class="[
                'h-7 w-52 text-left pl-5',
                highlightedUsers.includes(items[index - 1 + (rowIndex - 1) * 3])
                  ? `bg-${color} text-white font-bold`
                  : `text-${color}`,
              ]"
              style="border-radius: 20px;"
              @click.stop="toggleItem(items[index - 1 + (rowIndex - 1) * 3])"
            >
              <div class="flex flex-row items-center">
                <template v-if="items[index - 1 + (rowIndex - 1) * 3].iconUrl"
                  ><img
                    :src="
                      require('../../assets/' +
                        items[index - 1 + (rowIndex - 1) * 3].iconUrl)
                    "
                    class="mr-1"
                    width="20"
                    height="20"
                  />
                </template>
                <user-not-circle-icn
                  width="25px"
                  height="25px"
                  class="mr-2"
                  :fill="[
                    highlightedUsers.includes(
                      items[index - 1 + (rowIndex - 1) * 3],
                    )
                      ? 'white'
                      : '#2993CE',
                  ]"
                ></user-not-circle-icn>
                {{ items[index - 1 + (rowIndex - 1) * 3].name }}
              </div>
            </button>
          </td>
        </tr>
      </tbody>
      <textarea
        v-if="open"
        :class="`border-${color}`"
        placeholder="参加者を入力してください"
        class="w-full border focus:outline-none px-3 py-3 resize-none"
        style="border-radius: 20px; width:680px;margin-top: -24px;font-size:16px"
        rows="1"
        :value="modelValue ? modelValue : ''"
        @input="$emit('update:modelValue', $event.target.value)"
        @keyup="inputUser(items)"
        @mousedown.stop=""
      />
      <span
        v-if="open"
        :class="`text-${color}`"
        style="display:block;text-align:right;font-size:16px;height:90px;"
      >
        [入力数{{ modelValue ? count(modelValue) : 0 }}名]
      </span>
    </table>
  </Popover>
</template>

<script>
import { Popover, PopoverButton } from '@headlessui/vue'
import UserNotCircleIcn from '@/assets/icons/user-not-circle.svg?inline'
import { reactive, onMounted, onUnmounted, ref } from 'vue'

export default {
  name: 'AppUserPullDownList',

  components: {
    Popover,
    PopoverButton,
    UserNotCircleIcn,
  },

  emits: ['update:modelValue'],
  props: {
    color: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    modelValue: String,
  },

  setup(props, context) {
    let highlightedUsers = reactive([])
    let value = reactive([])
    const open = ref(false)
    const background = ref(null)

    onMounted(() => {
      background.value = document.getElementById('activities-dialog')
      background.value.addEventListener('mousedown', OnMousedown, false)
    })

    onUnmounted(() => {
      background.value.removeEventListener('mousedown', OnMousedown)
    })
    const OnMousedown = () => {
      open.value = false
    }
    // 議員リストの名前を選択した時の処理
    const toggleItem = item => {
      const index = highlightedUsers.indexOf(item)
      if (index === -1) {
        highlightedUsers.push(item)
        if (props.modelValue !== null) {
          value = props.modelValue.split(',')
        } else {
          value = []
        }
        value.push(item.name)
        if (value[0] === '') {
          value.shift()
        }
        context.emit('update:modelValue', value.join(','))
      } else {
        highlightedUsers.splice(index, 1)
        if (value.includes(item.name)) {
          value = value.filter(x => x != item.name)
        }
        context.emit('update:modelValue', value.join(','))
      }
    }

    // 手動で議員名を入力した時の処理
    const inputUser = list => {
      let inputUserList = []
      inputUserList = props.modelValue.split(',')
      // 入力エリアで手動で変更、削除され一致する名前がリストに存在しない場合
      highlightedUsers.forEach(item => {
        if (!inputUserList.includes(item.name)) {
          highlightedUsers.pop()
        }
      })

      // 手動で入力した名前が議員リストにあった場合、リストをハイライトする
      list.forEach(item => {
        const deleteWhitespace = []
        inputUserList.forEach(inputItem => {
          deleteWhitespace.push(inputItem.trim())
        })
        inputUserList = deleteWhitespace
        if (
          inputUserList.includes(item.name) &&
          !highlightedUsers.includes(item)
        ) {
          highlightedUsers.push(item)
        }
      })
    }

    // 参加者氏名入力エリアをクリックし議員リストを表示した時に議員リストをハイライトする
    const checkHighlightedUsers = (list, modelValue) => {
      if (modelValue) {
        let inputUserList = []
        inputUserList = modelValue.split(',')
        list.forEach(item => {
          const deleteWhitespace = []
          inputUserList.forEach(inputItem => {
            deleteWhitespace.push(inputItem.trim())
          })
          inputUserList = deleteWhitespace
          if (
            inputUserList.includes(item.name) &&
            !highlightedUsers.includes(item)
          ) {
            highlightedUsers.push(item)
          }
        })
        value = inputUserList
      }
    }

    // 参加者人数の表示
    const count = modelValue => {
      let memberCount = []
      for (let i = 0; i < modelValue.split(',').length; i++) {
        if (modelValue.split(',')[i]) {
          memberCount.push(modelValue.split(',')[i])
        }
      }
      return memberCount.length
    }

    return {
      toggleItem,
      inputUser,
      checkHighlightedUsers,
      count,
      highlightedUsers,
      value,
      open,
    }
  },
}
</script>

<style lang="scss" scoped>
#headlessui-popover-panel-4 {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
</style>
